import type { SlideProps } from "@/engine/app/offsite-config";

// Wortgleich mit den fünf Feldern des NW-Steckbriefs (offsite.config.ts
// requirementFields) — die Folie erklärt, was die Handys gleich anzeigen.
const FELDER = [
  {
    label: "Euer Anwendungsfall",
    tipp: "Ein Satz: Welchen wiederkehrenden Prozess nehmt ihr euch vor?",
  },
  {
    label: "Wie läuft es heute?",
    tipp: "Welche Systeme, wer macht was von Hand, wie oft?",
  },
  {
    label: "Was soll die KI übernehmen?",
    tipp: "Z. B.: Daten aus A und B vergleichen, Ergebnis nach C.",
  },
  {
    label: "Worauf kommt es an?",
    tipp: "Was muss stimmen, damit ihr dem Ergebnis vertraut?",
  },
  {
    label: "Ein konkretes Beispiel",
    tipp: "Ein echter Fall aus der letzten Woche, gern mit Zahlen.",
  },
];

export function Slide11cSoArbeitetIhr(_: SlideProps) {
  return (
    <div className="deck-root dark" style={{ background: "var(--svo-dunkelblau)" }}>
      <div className="deck-bg" aria-hidden="true" />

      <header className="deck-head">
        <div className="deck-eyebrow rise rise-1">Gleich seid ihr dran</div>
        <h1 className="deck-title rise rise-2">
          Fünf Felder — <br />
          <span className="accent">euer Steckbrief</span>
        </h1>
        <p className="deck-sub rise rise-3">
          Genau diese Felder erscheinen morgen früh auf euren Handys. Ihr denkt
          gemeinsam, einer tippt — alle anderen lesen live mit und können das
          Tippen jederzeit übernehmen.
        </p>
      </header>

      <div
        className="deck-cols2"
        style={{ gridTemplateColumns: "repeat(3, 1fr)", gridTemplateRows: "1fr 1fr", gap: 16 }}
      >
        {FELDER.map((f, i) => (
          <div key={f.label} className={`col-card rise rise-${(i % 3) + 4}`} style={{ padding: "20px 22px" }}>
            <div className="col-eyebrow">0{i + 1}</div>
            <h4 style={{ fontSize: "clamp(1rem, 1.6vw, 1.35rem)" }}>{f.label}</h4>
            <p style={{ fontSize: "clamp(0.85rem, 1.2vw, 1rem)" }}>{f.tipp}</p>
          </div>
        ))}
      </div>

      <footer className="deck-foot">
        <span>
          Morgen früh im Team definieren und verfeinern — die KI bewertet euren
          Steckbrief und baut daraus den Prototyp für die Ergebnisvorstellung.
        </span>
      </footer>
    </div>
  );
}
